namespace TabAurous.OMS {
    export interface TaxDetailsRow {
        TaxdetailsId?: number;
        TaxId?: number;
        GroupId?: number;
        SelectedtaxId?: number;
        TaxName?: string;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        Sys_Date?: string;
    }

    export namespace TaxDetailsRow {
        export const idProperty = 'TaxdetailsId';
        export const nameProperty = 'TaxName';
        export const localTextPrefix = 'OMS.TaxDetails';
        export const deletePermission = 'Masters:Tax:Delete';
        export const insertPermission = 'Masters:Tax:Add';
        export const readPermission = '*';
        export const updatePermission = 'Masters:Tax:Edit';

        export declare const enum Fields {
            TaxdetailsId = "TaxdetailsId",
            TaxId = "TaxId",
            GroupId = "GroupId",
            SelectedtaxId = "SelectedtaxId",
            TaxName = "TaxName",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            Sys_Date = "Sys_Date"
        }
    }
}
